/**
 * Sibling-model switcher for the product page "Выберите комплектацию" dropdown.
 * Progressively upgrades a plain GET form (works without JS) into an AJAX
 * fetch-and-swap of the product content, with history.pushState for the URL.
 */
(() => {
    function bindForm(form) {
        if (!form || form.dataset.siblingBound === 'true') {
            return;
        }
        form.dataset.siblingBound = 'true';

        const select = form.querySelector('[data-product-sibling-select]');
        const submitButton = form.querySelector('[data-product-sibling-submit]');
        if (!select) {
            return;
        }

        if (submitButton) {
            submitButton.hidden = true;
        }

        select.addEventListener('change', () => {
            form.requestSubmit ? form.requestSubmit() : form.submit();
        });

        form.addEventListener('submit', (event) => {
            const option = select.selectedOptions[0];
            const url = option && option.getAttribute('data-url');
            if (!url) {
                return;
            }
            event.preventDefault();
            if (url === window.location.pathname + window.location.search) {
                return;
            }
            swapTo(url);
        });
    }

    const SWAP_FADE_MS = 160; // matches --transition-fast in product.css

    async function swapTo(url) {
        const oldRoot = document.querySelector('[data-product-page]');
        if (oldRoot) {
            oldRoot.classList.add('is-swapping');
        }

        try {
            const [response] = await Promise.all([
                fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } }),
                new Promise((resolve) => setTimeout(resolve, SWAP_FADE_MS)),
            ]);
            if (!response.ok) {
                throw new Error(`Unexpected status ${response.status}`);
            }
            const html = await response.text();
            const parsed = new DOMParser().parseFromString(html, 'text/html');
            const newRoot = parsed.querySelector('[data-product-page]');
            if (!newRoot || !oldRoot) {
                throw new Error('Missing [data-product-page] in response');
            }

            newRoot.classList.add('is-swapping');
            oldRoot.replaceWith(newRoot);
            document.title = newRoot.getAttribute('data-page-title') || document.title;
            window.history.pushState({}, '', url);
            document.dispatchEvent(new CustomEvent('xtron:product-content-swapped', {
                detail: { root: newRoot },
            }));

            void newRoot.offsetHeight; // force reflow so opacity:0 is committed before we transition to visible
            newRoot.classList.remove('is-swapping');
        } catch (error) {
            console.warn('Product sibling switch failed, falling back to full navigation:', error);
            if (oldRoot) {
                oldRoot.classList.remove('is-swapping');
            }
            window.location.href = url;
        }
    }

    function init(root) {
        (root || document).querySelectorAll('[data-product-sibling-form]').forEach(bindForm);
    }

    init(document);
    document.addEventListener('xtron:product-content-swapped', (event) => {
        init(event.detail && event.detail.root);
    });
    window.addEventListener('popstate', () => {
        window.location.reload();
    });
})();
